import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Activity from './pages/Activity';
import ApplicationDetail from './pages/ApplicationDetail';
import Candidates from './pages/Candidates';
import CandidateDetail from './pages/CandidateDetail';
import Employers from './pages/Employers';
import EmployerDetail from './pages/EmployerDetail';
import AdminAccounts from './pages/AdminAccounts';
import JobOffers from './pages/JobOffers';
import VideoModeration from './pages/VideoModeration';
import MusicTracks from './pages/MusicTracks';
import Subscriptions from './pages/Subscriptions';
import Reports from './pages/Reports';
import Support from './pages/Support';
import Referentials from './pages/Referentials';
import Certifications from './pages/Certifications';
import TranslationReview from './pages/TranslationReview';
import CBDashboard from './pages/command-board/Dashboard';
import CampaignDetail from './pages/command-board/CampaignDetail';
import SeedAccounts from './pages/command-board/SeedAccounts';
import SeedOffers from './pages/command-board/SeedOffers';
import Engagement from './pages/command-board/Engagement';
import Analytics from './pages/command-board/Analytics';
import SeedTraces from './pages/command-board/SeedTraces';
import SkillUsage from './pages/command-board/SkillUsage';
import SkillProximity from './pages/command-board/SkillProximity';
import SkillFamilies from './pages/command-board/SkillFamilies';
import Logs from './pages/Logs';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <ErrorBoundary>
                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="activity" element={<Activity />} />
                    <Route path="applications/:id" element={<ApplicationDetail />} />
                    <Route path="candidates" element={<Candidates />} />
                    <Route path="candidates/:id" element={<CandidateDetail />} />
                    <Route path="employers" element={<Employers />} />
                    <Route path="employers/:id" element={<EmployerDetail />} />
                    <Route path="admins" element={<AdminAccounts />} />
                    <Route path="offers" element={<JobOffers />} />
                    <Route path="videos" element={<VideoModeration />} />
                    <Route path="music" element={<MusicTracks />} />
                    <Route path="subscriptions" element={<Subscriptions />} />
                    <Route path="reports" element={<Reports />} />
                    <Route path="support" element={<Support />} />
                    <Route path="referentials" element={<Referentials />} />
                    <Route path="certifications" element={<Certifications />} />
                    <Route path="translations" element={<TranslationReview />} />
                    <Route path="command-board" element={<CBDashboard />} />
                    <Route path="command-board/campaign/:name" element={<CampaignDetail />} />
                    <Route path="command-board/accounts" element={<SeedAccounts />} />
                    <Route path="command-board/offers" element={<SeedOffers />} />
                    <Route path="command-board/engagement" element={<Engagement />} />
                    <Route path="command-board/analytics" element={<Analytics />} />
                    <Route path="command-board/traces/:userId" element={<SeedTraces />} />
                    <Route path="command-board/skill-usage" element={<SkillUsage />} />
                    <Route path="command-board/skill-proximity" element={<SkillProximity />} />
                    <Route path="command-board/skill-families" element={<SkillFamilies />} />
                    <Route path="logs" element={<Logs />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
